<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row class="pa-2">
                                    <v-col cols="12">
                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="requisition_master_id.value.value"
                                            :items="getInvDueRequisitionList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            @update:modelValue="onRequisitionChange"
                                            :error-messages="requisition_master_id.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="requisitionDisable"
                                            :loading="requisitionLoading"
                                            clearable
                                        >
                                            <template #label>
                                                Requisition
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Requisition Delivery Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requisition_delivery_date.value.value"
                                            :error-messages="requisition_delivery_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Requisition Delivery Date
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-date-input>

                                        <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Requisition Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requisition_date.value.value"
                                            :error-messages="requisition_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Requisition Date
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-date-input>

                                        <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Require Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="require_date.value.value"
                                            :error-messages="require_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-date-input>

                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="warehouse_id.value.value"
                                            :items="getWarehouseList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="warehouse_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Warehouse
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                                                                <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="purpose_id.value.value"
                                            :items="getPurposeList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="purpose_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Purpose/Project
                                                <span class="text-red-accent-4"></span>
                                            </template>
                                        </v-autocomplete>

                                        <v-autocomplete
                                            label="Department"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="department_id.value.value"
                                            :items="getHrmDepartmentList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="department_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Department
                                                <span class="text-red-accent-4"></span>
                                            </template>                    
                                        </v-autocomplete>

                                        <v-text-field
                                            label="Requsition By"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Requsition By Mobile"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by_mobile.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Requsition By Email"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by_email.value.value"
                                            :error-messages="requsition_by_email.errorMessage.value"
                                            :disabled="true"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Item Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                    <v-row class="pt-2 justify-center">
                                        <!-- <v-col cols="8">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                @update:model-value="addCart"
                                                @keydown.enter="addCart"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>

                                            <input
                                                v-model="requisition_master_id.value.value"
                                                type="hidden"
                                            />
                                        </v-col> -->

                                        <!-- <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col> -->
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-start" style="width: 15%">Product Code</th>
                                                        <th class="text-left" style="width: 25%">Product Name</th>
                                                        <th class="text-start" style="width: 25%">Req. Qty.</th>
                                                        <th class="text-center" style="width: 15%">Available Qty.</th>
                                                        <th class="text-center" style="width: 15%">Approval Qty.</th>
                                                        <th class="text-center" style="width: 15%">Delivery Qty.</th>
                                                        <th class="text-center" style="width: 15%">Remaining Qty.</th>
                                                        <th class="text-center" style="width: 15%">Unit</th>
                                                        <th class="text-center" style="width: 10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                    v-for="(item, index) in cart"
                                                    v-if="cart.length > 0"
                                                    :key="index"
                                                    >
                                                        <td class="text-center py-1">{{ index + 1 }}</td>
                                                        
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                            {{ item.product_code }} 
                                                        </td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                            {{ item.product_name }}
                                                        </td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                            {{ item.req_qty }} 
                                                        </td>
                                                        
                                                        <td class="text-center py-1">
                                                            {{ item.available_qty }}
                                                        </td>

                                                        <td class="text-center py-1">
                                                            {{ item.approval_qty }}
                                                        </td>

                                                        <td class="text-right py-1">
                                                        <v-text-field
                                                        :reverse="false"
                                                        controlVariant="stacked"
                                                        label=""
                                                        style="width: 80px"
                                                        type="number"
                                                        :hideInput="false"
                                                        :inset="false"
                                                        :min="1"
                                                        density="compact"
                                                        :disabled="deliveryQtyDisable"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        v-model="item.qty"
                                                        hide-details
                                                        :error-messages="item.qty < 1 || item.qty > item.qty? 'Insufficient Stock': '' "
                                                        ></v-text-field>
                                                        </td>
                                                        <td class="text-center py-1">
                                                            {{ remainingQuantity(item) }}
                                                        </td>
                                                        
                                                        <td class="text-center py-1">
                                                            {{ item.unit_name }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                        <v-icon
                                                            size="small"
                                                            color="red"
                                                            class="delete-button"
                                                            @click="removeFromCart(index)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                            <v-skeleton-loader
                                                                type="heading"
                                                                :loading="loading"
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                            You have no item
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Description"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                            <v-btn
                                            class="bg-grey-darken-1 me-2"
                                            variant="flat"
                                            @click="submitForm(0)"
                                            >DRAFT</v-btn>
                                            <v-btn
                                            class="bg-primary"
                                            variant="flat"
                                            @click="submitForm(1)"
                                            >POST</v-btn>
                                            </v-layout>
                                        </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
    components: {},
    data: () => ({
        isEntryMode: true,
        panel: [0],
        panel2: [0],
        requisitionLoading: false,
        errorMessages: "",
        visible: false,
        deliveryQtyDisable: false,
        requisitionDisable: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getHrmDepartmentList.length === 0) {
            this.$store.dispatch("getHrmDepartmentList");
        }
        if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
        if (this.$store.getters.getPurposeList.length === 0) {
            this.$store.dispatch("getPurposeList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        if (this.$store.getters.getInvDueRequisitionList.length === 0) {
            this.requisitionLoading = true;
            this.$store.dispatch("getInvDueRequisitionList").then((response) => {
                this.requisitionLoading = false;
            });
        }
    },
    computed: {
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getPurposeList() {
            return this.$store.getters.getPurposeList;
        },
        getInvDueRequisitionList() {
            return this.$store.getters.getInvDueRequisitionList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) =>
                item.branch_id == this.$store.getters.getAuthUser.branch_id &&
                item.status == 1
            );
        },
    },
    methods: {
        remainingQuantity(item) {
        console.log(item)
            if(!item.qty) {
                return item.available_qty - item.delivery_qty;
            }else if((item.available_qty - item.qty - item.delivery_qty) < 0){
                return 0;   
            }else {
                const totalSub = item.available_qty - item.qty - item.delivery_qty;
                return totalSub
            }
        },
        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );

            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }

            if (cartInd > -1) {
                toast.error("Product already added in cart");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_name: product.name,
                product_code: product.code,
                req_qty: req_qty,
                available_qty: product.available_inventory_qty,
                qty: 1,
                approval_qty: product.approval_qty,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
            };

            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            this.product_id.value.value = null;
        },

        async onRequisitionChange(selectedId) {
            if (!selectedId) {
                this.requisition_date.value.value = null;
                this.require_date.value.value = null;
                this.warehouse_id.value.value = null;
                this.porpose_id.value.value = null;
                this.department_id.value.value = null;
                this.cart = []; // Clear cart when deselecting
                return;
            }

            try {
                const response = await this.$store.dispatch(
                    "getInvDueRequisitionById",
                    selectedId
                );
                
                this.requisition_date.value.value = response.requisition_date || "";
                this.require_date.value.value = response.require_date || "";
                this.warehouse_id.value.value = response.warehouse_id || null;
                this.purpose_id.value.value = response.purpose_id || null;
                this.department_id.value.value = response.department_id || null;
                
                // Clear existing cart before adding new items
                this.cart = [];
                
                console.log(response.requisition_details);
                
                // Add items to cart
                (response.requisition_details || []).forEach((item) => {
                    // Check if product exists and has necessary data
                    if (item.product) {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product.name || "",
                            product_code: item.product.code || "",
                            req_qty: item.req_qty || 0,
                            delivery_qty: item.delivery_qty || 0,
                            available_qty: item.product?.available_inventory_qty || 0,
                            qty: 1,
                            approval_qty: item.approval_qty || 0,
                            unit_id: item.product?.unit?.id || "",
                            unit_name: item.product?.unit?.name || "",
                        });
                    }
                    // if(item.delivery_qty === item.approval_qty) {
                    //     this.deliveryQtyDisable = true;
                    // }else{
                    //     this.deliveryQtyDisable = false;
                    // }
                });
            } catch (error) {
                console.error("Error loading requisition:", error);
            }
        }
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                requisition_master_id: yup.string().required().label("Requisition"),
                warehouse_id: yup.string().required().label("Warehouse"),
                // department_id: yup.string().required().label("Warehouse"),
                requisition_date: yup.date().required().label("Requisition Date"),
                requisition_delivery_date: yup.date().required().label("Requisition Delivery Date"),
                require_date: yup.date().nullable().label("Require Date"),
                // department_id: yup.number().positive().integer().required().label("Department Name"),
            }),
        });
        const requisition_delivery_master_id = useField("requisition_delivery_master_id");
        const requisition_id = useField("requisition_id");
        const require_date = useField("require_date");
        const product_id = useField("product_id");
        const pr_status = useField("pr_status");
        const status = useField("status");
        const employee_id = useField("employee_id");
        const department_id = useField("department_id");
        const warehouse_id = useField("warehouse_id");
        const purpose_id = useField("purpose_id");
        const requisition_master_id = useField("requisition_master_id");

        const requisition_date = useField("requisition_date");
        const requisition_delivery_date = useField("requisition_delivery_date");
        const remarks = useField("remarks");
        const requsition_by = useField("requsition_by");
        const requsition_by_mobile = useField("requsition_by_mobile");
        const requsition_by_email = useField("requsition_by_email");
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.cart = cart.value;
            store
            .dispatch("saveUpdateInvRequisitionDelivery", values)
            .then((response) => {
                resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "requisition-delivery-records" });
                    }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            submitForm,
            requisition_delivery_master_id,
            requisition_id,
            product_id,
            requisition_date,
            requisition_delivery_date,
            require_date,
            remarks,
            cart,
            requsition_by,
            requsition_by_mobile,
            requisition_master_id,
            requsition_by_email,
            pr_status,
            status,
            errorMessages,
            employee_id,
            department_id,
            warehouse_id,
            purpose_id,
            buttonText,
            loading,
        };
    },
    mounted() {
        let user = this.$store.getters.getAuthUser;
        this.requsition_by.value.value = user.full_name;
        this.requsition_by_mobile.value.value = user.mobile;
        this.requsition_by_email.value.value = user.email;

        const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
        this.requisition_date.value.value = today;
        this.requisition_delivery_date.value.value = today;
        this.require_date.value.value = today;

        const id = this.$route.query.id;
        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                .dispatch("getInvRequisitionDeliveryById", id)
                .then((data) => {
                    this.isEntryMode = false;
                    this.requisitionDisable = true;
                    let requisition = data;
                    this.requisition_delivery_master_id.value.value = requisition.id;
                    this.requisition_master_id.value.value = requisition.requisition_master_id;
                    this.requisition_delivery_date.value.value = requisition.requisition_delivery_date;
                    this.requisition_date.value.value = requisition?.requisition_master?.requisition_date;
                    this.require_date.value.value = requisition?.requisition_master?.require_date;
                    this.requisition_id.value.value = requisition.requisition_id;
                    this.warehouse_id.value.value = requisition.warehouse.id;
                    this.purpose_id.value.value = requisition?.purpose_id;
                    this.department_id.value.value = requisition.department.id;

                    this.product_id.value.value = null;
                    this.cart.value = [];

                    // Insert items one by one
                    (requisition.requisition_delivery_details || []).forEach((item) => {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product?.name || "",
                            product_code: item.product?.code || "",
                            available_qty: item.product?.available_inventory_qty,
                            delivery_qty: item.requisition_detail?.delivery_qty || 0,
                            req_qty: item.requisition_detail?.req_qty || 0,
                            qty: item.qty,
                            approval_qty: item.requisition_detail?.approval_qty,
                            unit_id: item.product.unit?.id || "",
                            unit_name: item.product.unit?.name || "",
                        });
                    });
                    this.remarks.value.value = requisition.remarks;
                    this.$store.commit("UNSET_LOADING");
                })
                .catch((error) => {
                    this.$store.commit("UNSET_LOADING");
                    console.error("Failed to fetch requisition:", error);
                });
            });
        } else {
            this.isEntryMode = true;
        }
    },
};
</script>
